import { selectors } from 'modules/common';
import { useCallback } from 'react';
import { mapMatchingInfo } from 'shared/components';
import { useLazyGetAccountLineItemMatchingSuggestions } from 'shared/data/webApp/v2';

import type { ExpandedQBooksAccountLineItem } from '../../../../../selectors/types/ExpandedQBooksAccountLineItem';

export const useConstructAccountLineItem = (
    request:
        | selectors.types.QBooksBillExpandedRequest
        | selectors.types.QBooksPoExpandedRequest
        | selectors.types.QBooksExpenseExpandedRequest,
    accountLineItems: ExpandedQBooksAccountLineItem[]
) => {
    const [triggerGetAccountLineItemMatchingSuggestions] = useLazyGetAccountLineItemMatchingSuggestions();

    const constructAccountLineItem = useCallback(
        async (lineItemId: string) => {
            const accountLineItem = accountLineItems.find((lineItem) => lineItem.id === lineItemId);
            const data = await triggerGetAccountLineItemMatchingSuggestions({
                params: {
                    path: { companyId: request.companyId },
                    query: {
                        requestId: request.id,
                        vendorId: request.details.vendor?.id || '',
                        billDate: request.details.date,
                        accountItemId: accountLineItem?.account?.id || '',
                    },
                },
            });

            const purchaseOrder = data.purchaseOrders?.find((purchaseOrder) =>
                purchaseOrder.accountBasedLines?.some(
                    (accountBasedLine) => accountBasedLine.lineItemId === accountLineItem?.matchedLineItemId
                )
            );

            if (!purchaseOrder) {
                return;
            }

            const { accountBasedLines, itemBasedLines, ...rest } = purchaseOrder;

            return mapMatchingInfo({
                ...rest,
                // TODO: BE don't have time to support correct types between v2 and v1, and we don't have time
                //  to wait, so as a temporary solution we casting types
                //  @see https://approvalmax.atlassian.net/browse/AM-20926
                accountBasedLine: accountBasedLines?.find(
                    (accountBasedLine) => accountBasedLine.lineItemId === accountLineItem?.matchedLineItemId
                ) as Parameters<typeof mapMatchingInfo>[0]['accountBasedLine'],
            });
        },
        [
            accountLineItems,
            triggerGetAccountLineItemMatchingSuggestions,
            request.companyId,
            request.details.date,
            request.details.vendor?.id,
            request.id,
        ]
    );

    return { constructAccountLineItem };
};
